import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import * as api from "./../../api/api";
import * as c from "./../../const";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, 0)",

    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#0d2da6",
    color: "white",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: 12,
    minHeight: 46,
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
    height: 46,
    "&$expanded": {
      minHeight: 46,
    },
  },
  content: {
    fontSize: 14,
    "&$expanded": {
      fontSize: "14px",
      margin: "12px 0",
      alignItems: "center",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    backgroundColor: "#f8f9fb",
    border: "1px solid #eee",
    padding: theme.spacing(2),
    marginBottom: 10,
    marginTop: -10,
  },
}))(MuiAccordionDetails);

export default function Body() {
  const [expanded, setExpanded] = useState("panel1");
  const [contributor, setContributor] = useState("");
  const [heading, setHeading] = useState("");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    contributorApi();
    newsApi();
  }, []);

  const contributorApi = async () => {
    try {
      const response = await api.contributors();
      setContributor(response);
    } catch (e) {}
  };

  const newsApi = async () => {
    try {
      let response = await api.headline();
      setHeading(response);
    } catch (e) {}
  };

  const pathName = window.location.pathname;

  return (
    <div>
      <Accordion
        square
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography style={{ color: "white", textAlign: "right" }}>
            Sponsoring Contributors
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              {Object.keys(contributor).map((index) => {
                if (contributor[index].type === "Sponsored Content") {
                  const url = c.URL;
                  let src = `${url}/${contributor[index].image}`;
                  return (
                    <li>
                      <a
                        href={contributor[index].url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={src}
                          className="img-fluid"
                          alt="brand"
                          height="80px"
                          width="80px"
                        />
                      </a>
                    </li>
                  );
                }
                return true;
              })}
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        square
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography style={{ color: "white" }}>Learn To Fly</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              {Object.keys(contributor).map((index) => {
                if (contributor[index].type === "Learn To Fly") {
                  const url = c.URL;
                  let src = `${url}/${contributor[index].image}`;
                  return (
                    <li>
                      <a
                        href={contributor[index].url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={src} className="img-fluid" alt="brand" />
                      </a>
                    </li>
                  );
                }
                return true;
              })}
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        square
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography style={{ color: "white" }}>Marque Clubs</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              {Object.keys(contributor).map((index) => {
                if (contributor[index].type === "Marque Clubs") {
                  const url = c.URL;
                  let src = `${url}/${contributor[index].image}`;
                  return (
                    <li>
                      <a
                        href={contributor[index].url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={src} className="img-fluid" alt="brand" />
                      </a>
                    </li>
                  );
                }
                return true;
              })}
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      {pathName == "/about-us" ? (
        <Accordion
          square
          // expanded={expanded === "panel3"}
          // onChange={handleChange("panel3")}
        >
          <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
            <Typography style={{ color: "white" }}>Sponsor Content</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <ul>
                {Object.keys(heading).map((i) => {
                  const title = heading[i].title;
                  const id = heading[i].id;
                  return (
                    <div key={i}>
                      <Link exact to={"/blog/" + id}>
                        <p className="sponsorContent my-1 mb-2">{title}</p>
                      </Link>
                    </div>
                  );
                })}
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : null}
    </div>
  );
}
